import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const ButtonsRow = styled.div`
  > *:not(:last-child) {
    margin-right: 20px;
  }
`;

export const ButtonStyled = styled.button`
  appearance: none;
  user-select: none;
  font-family: ${(props) => props.theme.fonts.gtEesti};
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 17px;
  text-align: center;
  text-transform: uppercase;
  border-radius: 4px;

  display: inline-flex;
  align-items: center;

  height: 40px;
  padding: 0 20px;

  color: ${(props) => (props.outline ? props.theme.colors.primary : props.theme.colors.white)};
  background-color: ${(props) =>
    props.outline ? props.theme.colors.white : props.theme.colors.primary};

  &:not(:disabled) {
    outline: none;
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.colors.primary};
    &:hover {
      background-color: ${(props) => props.theme.colors.primary20b};
      border: 1px solid ${(props) => props.theme.colors.primary20b};
      outline: none;
      color: ${(props) => props.theme.colors.white};
      text-decoration: none;
    }
    &:active {
      background-color: ${(props) => props.theme.colors.primary40b};
      border: 1px solid ${(props) => props.theme.colors.primary40b};
      outline: none;
    }
    &:focus {
      outline: none;
      appearance: none;
    }
  }

  &:disabled {
    border: 1px solid
      ${(props) => (props.outline ? props.theme.colors.black80w : props.theme.colors.black90w)};
    background-color: ${(props) =>
      props.outline ? props.theme.colors.white : props.theme.colors.black90w};
    color: rgba(0, 0, 0, 0.3);
  }

  ${(props) =>
    props.block &&
    css`
      display: block;
      width: 100%;
    `}
`;

export const ButtonStyledLink = styled.button`
  user-select: none;

  font-family: ${(props) => props.theme.fonts.gtEesti};
  font-size: ${(props) => (props.iconRight ? 20 : 14)}px;
  letter-spacing: 0.5px;
  line-height: ${(props) => (props.iconRight ? 23 : 17)}px;
  text-align: center;
  text-transform: ${(props) => (props.iconRight || props.noUpper ? 'unset' : 'uppercase')};

  display: inline-flex;
  align-items: center;

  svg {
    g {
      stroke: ${(props) => props.theme.colors.primary20b};
    }
  }

  margin: 0;
  padding: 0;

  color: ${(props) => (props.iconRight ? props.theme.colors.black : props.theme.colors.primary20b)};
  background-color: transparent;
  border: none;
  outline: none;

  &:not(:disabled) {
    cursor: pointer;
    &:hover {
      color: ${(props) =>
        props.iconRight ? props.theme.colors.black : props.theme.colors.primary40b};
      border: none;
      outline: none;
      g {
        stroke: ${(props) => props.theme.colors.primary40b};
      }
    }
    &:active {
      color: ${(props) =>
        props.iconRight ? props.theme.colors.black : props.theme.colors.primary60b};
      border: none;
      outline: none;
      g {
        stroke: ${(props) => props.theme.colors.primary60b};
      }
    }
    &:focus {
      outline: none;
      border: none;
      text-decoration: underline;
    }
  }

  &:disabled {
    color: rgba(0, 0, 0, 0.3);
    g {
      stroke: rgba(0, 0, 0, 0.3);
    }
  }

  & a {
    color: ${(props) => props.theme.colors.primary20b};
    display: ${(props) => (props.block ? 'block' : 'inline-block')};
    text-decoration: none;
    line-height: 1;

    &:focus,
    &:active,
    &:hover {
      color: ${(props) => props.theme.colors.primary40b};
      text-decoration: none;
    }
  }
`;

export const LinkStyled = styled(Link)`
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
  text-decoration: none;
  line-height: 1;
  &:focus,
  &:active,
  &:hover {
    text-decoration: none;
  }
  margin: 0;
`;

export const IconContainer = styled.div`
  display: flex;
  height: 1em;
  align-items: center;
  margin-left: ${(p) => (p.right ? 10 : 0)}px;
  margin-right: ${(p) => (p.left ? 10 : 0)}px;
`;
